import { ChangeDetectorRef, Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { AzureService } from '../services/azure.service';
import { AuthenticationService } from '../services/authentication.service';
import { VideoService } from '../services/video.service';
import { IMaterial, MaterialType } from '../../../assets/types/dtoTypes';
import {NgIf} from "@angular/common";

@Component({
  selector: 'app-upload-form',
  templateUrl: './upload-form.component.html',
  styleUrls: ['./upload-form.component.scss'],
  imports: [
    NgIf
  ],
  standalone: true
})
export class UploadFormComponent {
  private videoService = inject(VideoService);
  private cdr = inject(ChangeDetectorRef);
  private azureService = inject(AzureService);
  private authService = inject(AuthenticationService);


  @Input() update = false;

  @Input() userId :string;

  @Input() materialType: MaterialType;

  @Input() materialToUpdate : string;

  @Output()
    uploaded = new EventEmitter<string>();

  @Output()
    uploadedClicked = new EventEmitter<boolean>();

  progressInfos: { value: number, fileName: string }[] = [];

  message = '';

  id: string;

  selectedFile: File | null = null;

  selectedFileName: string = '';

  uploadedFiles: string;

  constructor() {
    this.id = this.authService.getIdFromAccessToken();
  }

  selectFilesAndUpload( event: { target: { files: FileList } } ): void {
    this.uploadedClicked.emit( true );
    this.message = '';
    this.progressInfos = [];
    const files = event.target.files as FileList;

    if ( files.length > 0 ) {
      const originalFile = files[0];
      const sanitizedFile = this.sanitizeFileName( originalFile );
      this.selectedFile = sanitizedFile;
      this.selectedFileName = sanitizedFile.name;
    }

    Array.from( files ).forEach( file => {
      const sanitizedFile = this.sanitizeFileName( file );
      this.progressInfos.push( { value: 0, fileName: sanitizedFile.name } );
      this.uploadFile( sanitizedFile );
    } );
  }

  private sanitizeFileName( file: File ): File {
    const sanitizedFileName = file.name.replace( /\s+/g, '_' );
    return new File( [ file ], sanitizedFileName, { type: file.type } );
  }



  uploadFile( file: File ): void {
    if (this.userId && this.id != this.userId) {
      this.id = this.userId;
    }
    if ( this.update && this.materialToUpdate ) {
      this.azureService.updateUserProfileMaterial( this.id, file ).subscribe(
        ( event ) => {
          this.updateMaterials( event, file );
          this.uploaded.emit( event.url );
        },
        error => {
          console.error( 'Error uploading file:', error );
          this.cdr.detectChanges();
        },
      );
    } else {
      this.azureService.createUserProfileMaterial( this.id, file ).subscribe(
        ( event ) => {
          this.updateMaterials( event, file );
          this.uploaded.emit( event.url );
        },
        error => {
          console.error( 'Error uploading file:', error );
          this.cdr.detectChanges();
        },
      );
    }
  }


  private updateMaterials( event: Partial<IMaterial>, file: File ) {
    this.uploadedFiles =  event.url ;
    this.message += `File "${file.name}" uploaded successfully.`;
    this.videoService.updateVideoUrls();
    this.cdr.detectChanges();
  }

}
